import React from 'react';
import {LoginLayout} from '../../Layouts/LoginLayout';
import { LoginForm } from 'src/Components/Form/LoginForm';
import {LoginPayloadRequest, loginUser} from '../../Context/AuthProvider/AuthProviderActions';
import {addAlert} from '../../Context/AlertProvider/AlertProviderActions';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {useAlertDispatcherState} from '../../Context/AlertProvider/AlertProvider';
import {useAuth0} from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import {Auth0LogoutButton} from '../../Components/Form/Auth0LogoutButton';

export const Login: React.FunctionComponent = (_props) => {
    const [validCompany, setValidCompany] = React.useState<string>('');
    const [useAut0, setUseAut0] = React.useState<boolean>(false);

    const { loginWithRedirect } = useAuth0();

    const authData = useAuthState();
    const authdispatch = useAuthDispatch();
    const alertDispatch = useAlertDispatcherState();

    const navigate = useNavigate();

    const handleBasicLogin = React.useCallback( async (payload:LoginPayloadRequest)=>{
        try {
            const responseLogin = await loginUser(payload, authdispatch);
            if (!responseLogin || !responseLogin.response || !responseLogin.response.user || responseLogin.response.user.id <= 0) return;

            addAlert('Autentificación exitosa', `Bienvenido ${ responseLogin.response.user.clave }` ,'success', alertDispatch );
        } catch (error) {
            console.log(error);
        }
    }, [alertDispatch, authdispatch] );

    const handleAuth0Login = React.useCallback( () => {
        loginWithRedirect({
            appState: {
                company:validCompany,
                action: 'login',
            }
        });
    }, [loginWithRedirect, validCompany]);

    React.useEffect( () => {
        if (useAut0){
            handleAuth0Login();
        }
    }, [handleAuth0Login, useAut0, validCompany]);

    React.useEffect( ()=>{
        if (authData.token !== undefined && authData.token !== ''){
            navigate('/');
        }
    }, [authData.token, navigate] );

    return (
        <React.Fragment>

            <LoginLayout loginTitle="Iniciar Sesión"
                         loginSubtitle="Inicie Sesión para poder acceder a sus archivos vinculados."
            >
                <LoginForm handleLogin={handleBasicLogin}
                           validCompany={validCompany}
                           setValidCompany={setValidCompany}
                           setUseAut0={ setUseAut0 }
                />

                <Auth0LogoutButton />
            </LoginLayout>

        </React.Fragment>
    );
};
